import httpManager from "@/app/shared/utils/httpManager";

/**
 * Editar un telefono
 *
 * @param {Object} phone Datos del telefono a editar
 *
 * @return {Promise<Object>} Datos del telefono editado
 */
export async function updatePhonesContact(id, phone) {
  const response = await httpManager.put(`/contacts/clients/phones/${id}/`, phone);
  return response?.data;
}
